// generated by genversion
export var version = '3.8.13';
//# sourceMappingURL=version.js.map